module.exports = __webpack_public_path__ + "img/icons8-buy-with-card.b8a046dc.svg";